import { Observable } from 'rxjs';
import { RegistrationData } from '../../model/login-register.model';

export abstract class RegistrationLoadAdapter {
  abstract loadRegistrationData(processId: string): Observable<RegistrationData>;
}
